__turbopack_context__.v({
  "arrow": "Row-module-scss-module__aQ3gfq__arrow",
  "item": "Row-module-scss-module__aQ3gfq__item",
});
